import { useGlobalContext } from '../../context/globalContext';
import Modal from '../../shared/modal/modal';

export function PortalModal() {
  const { shown, setShown, errorMessage } = useGlobalContext();

  const closeModal = () => {
    setShown(false);
  };

  return (
    <Modal
      type={'authError'}
      shown={shown}
      close={closeModal}
      error={errorMessage}
    />
  );
}
